import { getState } from './App';
import { userCanSeeComments } from './Auth';

export const defaultVideoCommentDuration = 2;

export const canSeeComments = () => {
  const state = getState();

  const { share } = state.Shares;

  return ((!share && userCanSeeComments()) || (share && share.allow_comments));
};
